import { http } from "utils/http";

export const pay = values => http.post("/payment", values);

export const sendContactInfo = (values, recaptchaToken) =>
  http.post("/contact", values, {
    headers: {
      "X-RECAPTCHA-KEY": recaptchaToken,
    },
  });

export const sendBecomePartnerInfo = values => http.post("/partner", values);

export default { pay, sendContactInfo };
